import GenericTag from './GenericTag';

export default GenericTag;
